export enum PaymentMethodEnum {
    Undefined = 0,

    // VISA, visa/dankort, LeumiVisa
    Visa = 1,

    // MasterCard, LeumiMasterCard
    MasterCard = 2,

    // american express, AmericanExpress
    AmericanExpress = 3,

    // Discover, elo/discover
    Discover = 4,

    PayPal = 7,

    // Diners, diners club international
    Diners = 9,

    JCB = 10,

    AliPay = 13,

    // china union pay, UnionPay
    UnionPay = 14,
}